// extracted by mini-css-extract-plugin
module.exports = {"listItem":"TextList_listItem_1oKYk","text":"TextList_text_3ilf2","description":"TextList_description_3igFJ"};